import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[lumTextOnly]',
})
export class TextOnlyDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  // Prevent special characters and numbers
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }

    // Prevent the first character from being a space
    if (this.el.nativeElement.value.length === 0 && event.key === ' ') {
      event.preventDefault();
    }
  }

  // Prevent spaces-only input
  @HostListener('input', ['$event']) onInput(): void {
    const value = this.el.nativeElement.value;

    // Trim spaces and prevent input from being only spaces
    if (value.trim() === '') {
      this.control.control?.setValue('');
    }
  }

  // Trim spaces on blur
  @HostListener('blur', ['$event']) onBlur(): void {
    const value = this.el.nativeElement.value;
    this.control.control?.setValue(value.trim());
  }
} 